import * as tslib_1 from "tslib";
import { GetReleaseNotesUrl, GetNewsFeedUrl, AlertMessagesURL, GetAlertMessageTemplatesURL, UpdateAlertsURL, CreateReleaseNotesUrl, UpdateReleaseNotesUrl, } from '../constants';
import _ from 'lodash';
export function GetNewsFeed(api) {
    return (symbols, updatedSince, channels) => {
        var symbs = _.isArray(symbols) ? symbols : [symbols];
        return api.get(GetNewsFeedUrl, { symbols: symbs.join(','), updatedSince, channels });
    };
}
export const create = (api) => {
    return (releaseNote) => {
        return api.authenticated().post(CreateReleaseNotesUrl, releaseNote, {
            headers: { Accept: 'application/json' },
        });
    };
};
export const info = (api) => ({
    get: (request) => tslib_1.__awaiter(this, void 0, void 0, function* () {
        const page = request.page ? request.page : 0;
        const pageSize = request.pageSize ? request.pageSize : 5;
        const searchRequest = Object.assign({}, request, { page,
            pageSize });
        return yield api.get(GetReleaseNotesUrl, searchRequest);
    }),
    createAlert: (alert) => {
        return api.authenticated().post(AlertMessagesURL, alert);
    },
    getActiveAlerts: (request) => tslib_1.__awaiter(this, void 0, void 0, function* () {
        return yield api.get(AlertMessagesURL, request);
    }),
    getAlertTemplates: (request) => tslib_1.__awaiter(this, void 0, void 0, function* () {
        return yield api.get(GetAlertMessageTemplatesURL, request);
    }),
    updateAlert: (request) => tslib_1.__awaiter(this, void 0, void 0, function* () {
        return yield api.authenticated().put(UpdateAlertsURL(request.id, request.active), request);
    }),
    news: GetNewsFeed(api),
    createReleaseNote: create(api),
    updateReleaseNote: (releaseNote) => {
        return api.authenticated().put(UpdateReleaseNotesUrl(releaseNote.id), {
            releaseDate: releaseNote.releaseDate,
            summary: releaseNote.summary,
            restrictedToUserLevel: releaseNote.restrictedToUserLevel,
            type: releaseNote.type,
        });
    },
});
//# sourceMappingURL=information.js.map